<adapt-confirmation-dialog (closed)="onDialogClosed($event)"
                           (initialised)="onInitialised($event)">
    <p>Are you sure you wish to delete this action?</p>

    <ng-container *adaptLoading="loadingRelatedInfo">
        @if (linkedMeeting) {
            <p>
                It will be removed from the "
                <adapt-link-team-meeting [meeting]="linkedMeeting"></adapt-link-team-meeting>
                " meeting.
            </p>
        }
        @if (catchupLink) {
            <p class="d-flex">
                It will be removed from the "
                <adapt-catchup-link [catchupLink]="catchupLink"></adapt-catchup-link>
                "
            </p>
        }

        @if (careerValuationLink) {
            <p class="d-flex">
                It will be removed from the "
                <adapt-cvt-link [careerValuationLink]="careerValuationLink"></adapt-cvt-link>
                "
            </p>
        }

        @if (itemLinks.length > 0) {
            <p>It will be unlinked from the following actions:</p>
            <ul>
                @for (link of itemLinks; track link) {
                    <li>
                        <adapt-item-link [item]="link.linkedItem"
                                         [showStatus]="true"
                                         [showSummary]="true"></adapt-item-link>
                    </li>
                }
            </ul>
        }

        @if (objectiveLinks.length > 0) {
            <p>It will be removed from the following objectives:</p>
            <ul>
                @for (objectiveLink of objectiveLinks; track objectiveLink) {
                    <li>
                        <adapt-link-objective [objective]="objectiveLink.objective1"
                                              [displayInline]="true"></adapt-link-objective>
                    </li>
                }
            </ul>
        }
    </ng-container>
</adapt-confirmation-dialog>
